var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComponentHover83(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_83_1",
    "data-name": "Component 83 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 350.825,
    height: 328,
    viewBox: "0 0 350.825 328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 328,
    height: 328,
    rx: 164,
    transform: "translate(11.413)",
    fill: "#f8f8f8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3497641",
    "data-name": 3497641,
    transform: "translate(0 -21.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(0 54.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16177",
    "data-name": "Group 16177"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 350.825,
    height: 0.175,
    transform: "translate(0 229.755)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 14.882,
    height: 0.175,
    transform: "translate(36.809 236.435)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 59.619,
    height: 0.175,
    transform: "translate(120.08 234.534)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 26.74,
    height: 0.175,
    transform: "translate(47.481 242.953)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 30.304,
    height: 0.175,
    transform: "translate(285.368 241.775)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 8.399,
    height: 0.175,
    transform: "translate(274.675 241.775)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 16.138,
    height: 0.175,
    transform: "translate(244.097 238.814)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 33.988,
    height: 0.175,
    transform: "translate(201.998 238.814)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47784",
    "data-name": "Path 47784",
    d: "M177.7,253.412H42.206a4.01,4.01,0,0,1-4.006-4.006V58.956a4.01,4.01,0,0,1,4.006-4.006H177.7a4.01,4.01,0,0,1,4.006,4.006V249.405A4.01,4.01,0,0,1,177.7,253.412ZM42.206,55.125a3.836,3.836,0,0,0-3.831,3.831V249.405a3.836,3.836,0,0,0,3.831,3.831H177.7a3.836,3.836,0,0,0,3.831-3.831V58.956a3.836,3.836,0,0,0-3.831-3.831Z",
    transform: "translate(-11.397 -54.95)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47785",
    "data-name": "Path 47785",
    d: "M394,253.412H258.506a4.01,4.01,0,0,1-4.006-4.006V58.956a4.01,4.01,0,0,1,4.006-4.006H394A4.01,4.01,0,0,1,398,58.956V249.405A4.01,4.01,0,0,1,394,253.412ZM258.506,55.125a3.836,3.836,0,0,0-3.831,3.831V249.405a3.836,3.836,0,0,0,3.831,3.831H394a3.836,3.836,0,0,0,3.831-3.831V58.956A3.836,3.836,0,0,0,394,55.125Z",
    transform: "translate(-75.93 -54.95)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16188",
    "data-name": "Group 16188",
    transform: "translate(51.382 15.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16180",
    "data-name": "Group 16180",
    transform: "translate(0 130.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16178",
    "data-name": "Group 16178",
    transform: "translate(1.256 1.137)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    "data-name": "Rectangle 299",
    width: 10.805,
    height: 83.16,
    transform: "translate(10.812 83.16) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 94.575,
    height: 83.16,
    transform: "translate(10.812)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    "data-name": "Rectangle 301",
    width: 83.033,
    height: 44.478,
    transform: "translate(23.211 31.385)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    width: 83.033,
    height: 14.643,
    transform: "translate(23.211 12.019)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_303",
    "data-name": "Rectangle 303",
    width: 0.744,
    height: 44.478,
    transform: "translate(23.211 75.862) rotate(180)",
    fill: "#e6e6e6",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    "data-name": "Rectangle 304",
    width: 0.744,
    height: 14.643,
    transform: "translate(23.211 26.663) rotate(180)",
    fill: "#e6e6e6",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_305",
    "data-name": "Rectangle 305",
    width: 105.619,
    height: 1.88,
    transform: "translate(105.619 5.389) rotate(180)",
    fill: "#e6e6e6",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16179",
    "data-name": "Group 16179"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 12.068,
    height: 5.438,
    transform: "translate(12.068 5.438) rotate(180)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 95.838,
    height: 5.438,
    transform: "translate(12.068)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16183",
    "data-name": "Group 16183",
    transform: "translate(12.672 86.899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16181",
    "data-name": "Group 16181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47786",
    "data-name": "Path 47786",
    d: "M130.4,231.579a5.71,5.71,0,0,1-1.017-2.926,9.219,9.219,0,0,1,.274-3.157,14.639,14.639,0,0,1,2.877-5.543,25.606,25.606,0,0,1,2.1-2.252c.386-.33.772-.667,1.165-.982a12.8,12.8,0,0,1,1.207-.926,29.651,29.651,0,0,1,2.575-1.6c.912-.442,1.81-.891,2.758-1.242-.66.786-1.375,1.473-2.077,2.168s-1.361,1.41-2.07,2.077-1.319,1.4-1.993,2.077c-.323.351-.617.716-.933,1.074a12,12,0,0,0-.912,1.081,21.589,21.589,0,0,0-2.968,4.666,12.522,12.522,0,0,0-.87,2.624,7.869,7.869,0,0,0-.119,2.877Z",
    transform: "translate(-102.646 -204.341)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47787",
    "data-name": "Path 47787",
    d: "M102.65,228.863a7.575,7.575,0,0,0,.456-2.6,7.843,7.843,0,0,0-.091-1.228,8.7,8.7,0,0,0-.33-1.151,10.94,10.94,0,0,0-2.8-3.908c-.295-.295-.646-.547-.968-.828a9.266,9.266,0,0,0-1-.807c-.716-.491-1.368-1.074-2.133-1.53-.372-.246-.737-.491-1.109-.751s-.73-.526-1.123-.758a27.28,27.28,0,0,1-2.266-1.6,26.365,26.365,0,0,1,2.743.554,8.93,8.93,0,0,1,1.333.428c.435.161.87.337,1.305.519l.653.274c.211.1.414.225.624.337.414.225.821.47,1.235.709a9.644,9.644,0,0,1,1.179.828c.372.309.765.582,1.123.926a9.5,9.5,0,0,1,2.975,5.164,3.133,3.133,0,0,1,.07.772c0,.26.021.512,0,.765a6.849,6.849,0,0,1-.309,1.48,5.3,5.3,0,0,1-1.579,2.4Z",
    transform: "translate(-91.29 -204.565)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47788",
    "data-name": "Path 47788",
    d: "M104.663,227.174a16.05,16.05,0,0,0,.133-5.655,14.993,14.993,0,0,0-1.775-5.038l-.7-1.158c-.26-.372-.554-.723-.821-1.095l-.407-.561-.47-.512c-.316-.344-.617-.695-.926-1.052-.66-.667-1.354-1.326-2.021-2.028-.723-.646-1.452-1.291-2.154-2.035a28.636,28.636,0,0,1,2.807,1.095,29.032,29.032,0,0,1,2.582,1.593q.589.484,1.179.989l.582.512.519.582c.344.393.688.786,1.01,1.193l.842,1.333a11.938,11.938,0,0,1,1.565,6.083,9.528,9.528,0,0,1-1.958,5.761Z",
    transform: "translate(-92.552 -202.876)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47789",
    "data-name": "Path 47789",
    d: "M126.673,226.017a27.589,27.589,0,0,1-3.529-5.69,37.609,37.609,0,0,1-2.308-6.3,31.456,31.456,0,0,1-.975-6.68,18.929,18.929,0,0,1,1.017-6.666c.2,2.245.442,4.371.807,6.49.407,2.112.877,4.2,1.4,6.273.547,2.077,1.144,4.147,1.754,6.238s1.242,4.175,1.824,6.35Z",
    transform: "translate(-99.814 -200.68)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47790",
    "data-name": "Path 47790",
    d: "M123.951,225.708a31.557,31.557,0,0,1-4.448-5.319,43.615,43.615,0,0,1-3.417-6.034,36.017,36.017,0,0,1-2.294-6.581,21.312,21.312,0,0,1-.505-6.953c.709,2.224,1.438,4.329,2.252,6.406.835,2.077,1.74,4.112,2.659,6.146.94,2.035,1.908,4.056,2.884,6.1s1.951,4.091,2.863,6.231Z",
    transform: "translate(-97.821 -200.722)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47791",
    "data-name": "Path 47791",
    d: "M125.819,230.8a31.875,31.875,0,0,1-5.522-4.189,43.7,43.7,0,0,1-4.68-5.115,36.4,36.4,0,0,1-3.7-5.9,21.163,21.163,0,0,1-2.042-6.666c1.186,2.014,2.365,3.894,3.628,5.747s2.617,3.62,3.964,5.4c1.368,1.768,2.764,3.522,4.168,5.3s2.814,3.55,4.182,5.431Z",
    transform: "translate(-96.833 -203.141)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47792",
    "data-name": "Path 47792",
    d: "M120.283,227.21a24.178,24.178,0,0,1-5.3-3.592,32.643,32.643,0,0,1-4.392-4.68,28.163,28.163,0,0,1-3.3-5.543,18.643,18.643,0,0,1-1.572-6.245c1.074,1.873,2.056,3.663,3.186,5.382s2.294,3.375,3.543,5,2.526,3.221,3.845,4.82,2.659,3.193,4,4.869Z",
    transform: "translate(-95.592 -202.61)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47793",
    "data-name": "Path 47793",
    d: "M130.1,230.7a7.028,7.028,0,0,1-2.891-4.82,10.116,10.116,0,0,1,.912-5.725l.295-.66.358-.617.751-1.207q.432-.558.884-1.095a10.942,10.942,0,0,1,.933-1.038,24.392,24.392,0,0,1,2.1-1.81,25.431,25.431,0,0,1,2.343-1.452,26.992,26.992,0,0,1-1.523,2.259c-.519.723-.982,1.473-1.495,2.168-.484.723-.905,1.459-1.375,2.168l-.589,1.116-.3.547-.239.568a12.214,12.214,0,0,0-1.221,4.666A10.155,10.155,0,0,0,130.1,230.7Z",
    transform: "translate(-101.975 -204.138)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47794",
    "data-name": "Path 47794",
    d: "M128.057,227.228a11.224,11.224,0,0,1-2.975-5,11.037,11.037,0,0,1-.084-6.041,10.234,10.234,0,0,1,1.235-2.821,11.046,11.046,0,0,1,1.923-2.329,12.534,12.534,0,0,1,5.031-2.891,37.01,37.01,0,0,0-3.663,4.119,14.753,14.753,0,0,0-1.361,2.2,11.085,11.085,0,0,0-.905,2.344,13.853,13.853,0,0,0-.372,5.066,25.8,25.8,0,0,0,1.179,5.354Z",
    transform: "translate(-101.233 -202.909)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47795",
    "data-name": "Path 47795",
    d: "M119.961,228.489,108.98,217.95l.442,10.335Z",
    transform: "translate(-96.568 -205.832)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16182",
    "data-name": "Group 16182",
    transform: "translate(6.224 21.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47796",
    "data-name": "Path 47796",
    d: "M129.328,231.37H100.16l3.817,21.674h21.534Z",
    transform: "translate(-100.16 -231.37)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47797",
    "data-name": "Path 47797",
    d: "M111.106,231.37H100.16l3.817,21.674h5.754Z",
    transform: "translate(-100.16 -231.37)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16184",
    "data-name": "Group 16184",
    transform: "translate(19.443)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 58.875,
    height: 74.01,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 69.618,
    height: 74.01,
    transform: "translate(2.259)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    width: 62.349,
    height: 57.956,
    transform: "translate(8.09 68.172) rotate(-90)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16187",
    "data-name": "Group 16187",
    transform: "translate(156.629 66.32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16185",
    "data-name": "Group 16185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47798",
    "data-name": "Path 47798",
    d: "M393.975,319.433H304.41L296.46,171.35h89.566Z",
    transform: "translate(-296.46 -171.35)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47799",
    "data-name": "Path 47799",
    d: "M397.875,319.433H308.31L300.36,171.35h89.566Z",
    transform: "translate(-297.624 -171.35)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16186",
    "data-name": "Group 16186",
    transform: "translate(26.172 15.275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47800",
    "data-name": "Path 47800",
    d: "M371.919,310.653h-8l.323-117.533h8Z",
    transform: "translate(-342.758 -193.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47801",
    "data-name": "Path 47801",
    d: "M402.069,310.653h-8l.33-117.533h7.992Z",
    transform: "translate(-351.753 -193.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47802",
    "data-name": "Path 47802",
    d: "M341.759,310.653h-8l.33-117.533h8Z",
    transform: "translate(-333.76 -193.12)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    transform: "translate(39.37 300.507)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_lt_Path_gt_",
    "data-name": "&lt;Path&gt;",
    cx: 136.043,
    cy: 7.943,
    rx: 136.043,
    ry: 7.943,
    transform: "translate(0 0)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sliders",
    transform: "translate(166.01 78.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16193",
    "data-name": "Group 16193",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16189",
    "data-name": "Group 16189"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 16.545,
    height: 0.702,
    transform: "translate(104.465 160.426) rotate(-86.86)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    "data-name": "Rectangle 312",
    width: 8.525,
    height: 0.702,
    transform: "translate(105.678 138.404) rotate(-86.86)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47804",
    "data-name": "Path 47804",
    d: "M365.079,280.915H245.7a9.031,9.031,0,0,1-9.086-9.613l9.472-172.69A10.306,10.306,0,0,1,256.225,89H375.6a9.031,9.031,0,0,1,9.086,9.613L375.218,271.3A10.306,10.306,0,0,1,365.079,280.915Z",
    transform: "translate(-236.6 -89)",
    fill: "#fff",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47803",
    "data-name": "Path 47803",
    d: "M363.04,280.915H245.71a9.031,9.031,0,0,1-9.086-9.613L246.1,98.613A10.306,10.306,0,0,1,256.235,89h117.33a9.031,9.031,0,0,1,9.086,9.613L373.179,271.3A10.306,10.306,0,0,1,363.04,280.915Z",
    transform: "translate(-236.603 -89)",
    fill: "#7aa3ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47805",
    "data-name": "Path 47805",
    d: "M294.059,130.165H271.866a3.816,3.816,0,0,1-3.838-4.063h0a4.354,4.354,0,0,1,4.28-4.063H294.5a3.816,3.816,0,0,1,3.838,4.063h0A4.354,4.354,0,0,1,294.059,130.165Z",
    transform: "translate(-245.974 -98.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47806",
    "data-name": "Path 47806",
    d: "M305.013,124.724a7.811,7.811,0,0,1-7.7,7.3,6.84,6.84,0,0,1-6.9-7.3,7.811,7.811,0,0,1,7.7-7.3A6.84,6.84,0,0,1,305.013,124.724Z",
    transform: "translate(-252.649 -97.479)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47807",
    "data-name": "Path 47807",
    d: "M292.029,167.175H269.836A3.816,3.816,0,0,1,266,163.113h0a4.354,4.354,0,0,1,4.28-4.063h22.193a3.816,3.816,0,0,1,3.838,4.063h0A4.354,4.354,0,0,1,292.029,167.175Z",
    transform: "translate(-245.369 -109.899)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16190",
    "data-name": "Group 16190",
    transform: "translate(26.518 45.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47808",
    "data-name": "Path 47808",
    d: "M289.013,161.734a7.811,7.811,0,0,1-7.7,7.3,6.84,6.84,0,0,1-6.9-7.3,7.811,7.811,0,0,1,7.7-7.3A6.84,6.84,0,0,1,289.013,161.734Z",
    transform: "translate(-274.394 -154.43)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47809",
    "data-name": "Path 47809",
    d: "M289.013,161.734a7.811,7.811,0,0,1-7.7,7.3,6.84,6.84,0,0,1-6.9-7.3,7.811,7.811,0,0,1,7.7-7.3A6.84,6.84,0,0,1,289.013,161.734Z",
    transform: "translate(-274.394 -154.43)",
    fill: "#fafafa",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47810",
    "data-name": "Path 47810",
    d: "M265.776,241.2h22.193a4.349,4.349,0,0,0,4.28-4.063h0a3.82,3.82,0,0,0-3.838-4.063H266.218a4.349,4.349,0,0,0-4.28,4.063h0A3.82,3.82,0,0,0,265.776,241.2Z",
    transform: "translate(-244.157 -131.983)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16191",
    "data-name": "Group 16191",
    transform: "translate(17.769 97.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47811",
    "data-name": "Path 47811",
    d: "M261.935,235.754a6.84,6.84,0,0,0,6.9,7.3,7.806,7.806,0,0,0,7.7-7.3,6.84,6.84,0,0,0-6.9-7.3A7.806,7.806,0,0,0,261.935,235.754Z",
    transform: "translate(-261.924 -228.45)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47812",
    "data-name": "Path 47812",
    d: "M261.935,235.754a6.84,6.84,0,0,0,6.9,7.3,7.806,7.806,0,0,0,7.7-7.3,6.84,6.84,0,0,0-6.9-7.3A7.806,7.806,0,0,0,261.935,235.754Z",
    transform: "translate(-261.924 -228.45)",
    fill: "#fafafa",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47813",
    "data-name": "Path 47813",
    d: "M285.939,278.205H263.746a3.816,3.816,0,0,1-3.838-4.063h0a4.354,4.354,0,0,1,4.28-4.063h22.193a3.816,3.816,0,0,1,3.838,4.063h0A4.354,4.354,0,0,1,285.939,278.205Z",
    transform: "translate(-243.552 -143.025)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47814",
    "data-name": "Path 47814",
    d: "M296.893,272.764a7.811,7.811,0,0,1-7.7,7.3,6.84,6.84,0,0,1-6.9-7.3,7.812,7.812,0,0,1,7.711-7.3,6.836,6.836,0,0,1,6.9,7.3Z",
    transform: "translate(-250.226 -141.647)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47815",
    "data-name": "Path 47815",
    d: "M267.806,204.185H290a4.349,4.349,0,0,0,4.28-4.063h0a3.82,3.82,0,0,0-3.838-4.063H268.248a4.349,4.349,0,0,0-4.28,4.063h0A3.82,3.82,0,0,0,267.806,204.185Z",
    transform: "translate(-244.763 -120.941)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16192",
    "data-name": "Group 16192",
    transform: "translate(19.2 71.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47816",
    "data-name": "Path 47816",
    d: "M263.975,198.744a6.84,6.84,0,0,0,6.9,7.3,7.806,7.806,0,0,0,7.7-7.3,6.84,6.84,0,0,0-6.9-7.3A7.806,7.806,0,0,0,263.975,198.744Z",
    transform: "translate(-263.964 -191.44)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47817",
    "data-name": "Path 47817",
    d: "M263.975,198.744a6.84,6.84,0,0,0,6.9,7.3,7.806,7.806,0,0,0,7.7-7.3,6.84,6.84,0,0,0-6.9-7.3A7.806,7.806,0,0,0,263.975,198.744Z",
    transform: "translate(-263.964 -191.44)",
    fill: "#fafafa",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47818",
    "data-name": "Path 47818",
    d: "M394.852,124.722H326.876a1.526,1.526,0,0,1-1.537-1.621h0a1.741,1.741,0,0,1,1.712-1.621h67.976a1.526,1.526,0,0,1,1.537,1.621h0A1.741,1.741,0,0,1,394.852,124.722Z",
    transform: "translate(-263.074 -98.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47819",
    "data-name": "Path 47819",
    d: "M348.678,132.822H326.436A1.526,1.526,0,0,1,324.9,131.2h0a1.741,1.741,0,0,1,1.712-1.621h22.242a1.526,1.526,0,0,1,1.537,1.621h0A1.741,1.741,0,0,1,348.678,132.822Z",
    transform: "translate(-262.943 -101.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47820",
    "data-name": "Path 47820",
    d: "M382.581,272.762H318.766a1.526,1.526,0,0,1-1.537-1.621h0a1.741,1.741,0,0,1,1.712-1.621h63.815a1.527,1.527,0,0,1,1.537,1.621h0A1.741,1.741,0,0,1,382.581,272.762Z",
    transform: "translate(-260.655 -142.858)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47821",
    "data-name": "Path 47821",
    d: "M332.517,280.852h-14.2a1.527,1.527,0,0,1-1.537-1.621h0a1.741,1.741,0,0,1,1.712-1.621h14.2a1.527,1.527,0,0,1,1.537,1.621h0A1.741,1.741,0,0,1,332.517,280.852Z",
    transform: "translate(-260.52 -145.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47822",
    "data-name": "Path 47822",
    d: "M392.557,166.58H324.581a1.741,1.741,0,0,0-1.712,1.621h0a1.522,1.522,0,0,0,1.537,1.621h67.976a1.741,1.741,0,0,0,1.712-1.621h0A1.522,1.522,0,0,0,392.557,166.58Z",
    transform: "translate(-262.337 -112.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47823",
    "data-name": "Path 47823",
    d: "M347.273,158.48H325.031a1.741,1.741,0,0,0-1.712,1.621h0a1.522,1.522,0,0,0,1.537,1.621H347.1a1.741,1.741,0,0,0,1.712-1.621h0A1.522,1.522,0,0,0,347.273,158.48Z",
    transform: "translate(-262.472 -109.729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47824",
    "data-name": "Path 47824",
    d: "M339.693,198.742H322.826a1.526,1.526,0,0,1-1.537-1.621h0A1.741,1.741,0,0,1,323,195.5h16.868a1.526,1.526,0,0,1,1.537,1.621h0A1.741,1.741,0,0,1,339.693,198.742Z",
    transform: "translate(-261.866 -120.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47825",
    "data-name": "Path 47825",
    d: "M365.471,198.742h-9.935A1.526,1.526,0,0,1,354,197.121h0a1.741,1.741,0,0,1,1.712-1.621h9.935a1.526,1.526,0,0,1,1.537,1.621h0A1.741,1.741,0,0,1,365.471,198.742Z",
    transform: "translate(-271.625 -120.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47826",
    "data-name": "Path 47826",
    d: "M344.618,206.832H322.376a1.526,1.526,0,0,1-1.537-1.621h0a1.741,1.741,0,0,1,1.712-1.621h22.242a1.526,1.526,0,0,1,1.537,1.621h0A1.741,1.741,0,0,1,344.618,206.832Z",
    transform: "translate(-261.732 -123.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47827",
    "data-name": "Path 47827",
    d: "M297.981,312.767H260.106a2.135,2.135,0,0,1-2.147-2.273h0a2.436,2.436,0,0,1,2.393-2.273h37.875a2.135,2.135,0,0,1,2.147,2.273h0A2.436,2.436,0,0,1,297.981,312.767Z",
    transform: "translate(-242.971 -154.404)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47828",
    "data-name": "Path 47828",
    d: "M387.421,312.767H329.086a2.135,2.135,0,0,1-2.147-2.273h0a2.436,2.436,0,0,1,2.393-2.273h58.335a2.135,2.135,0,0,1,2.147,2.273h0a2.436,2.436,0,0,1-2.393,2.273Z",
    transform: "translate(-263.551 -154.404)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47829",
    "data-name": "Path 47829",
    d: "M337.439,324.1H259.486a2.135,2.135,0,0,1-2.147-2.273h0a2.436,2.436,0,0,1,2.393-2.273h77.953a2.135,2.135,0,0,1,2.147,2.273h0A2.436,2.436,0,0,1,337.439,324.1Z",
    transform: "translate(-242.786 -157.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47830",
    "data-name": "Path 47830",
    d: "M361.552,335.427H258.866a2.135,2.135,0,0,1-2.147-2.273h0a2.436,2.436,0,0,1,2.393-2.273H361.8a2.135,2.135,0,0,1,2.147,2.273h0A2.436,2.436,0,0,1,361.552,335.427Z",
    transform: "translate(-242.601 -161.165)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47831",
    "data-name": "Path 47831",
    d: "M330.26,240.6h-9.739a1.741,1.741,0,0,0-1.712,1.621h0a1.522,1.522,0,0,0,1.537,1.621h9.739a1.741,1.741,0,0,0,1.712-1.621h0A1.522,1.522,0,0,0,330.26,240.6Z",
    transform: "translate(-261.126 -134.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47832",
    "data-name": "Path 47832",
    d: "M354.361,240.6h-11.29a1.741,1.741,0,0,0-1.712,1.621h0a1.522,1.522,0,0,0,1.537,1.621h11.29a1.741,1.741,0,0,0,1.712-1.621h0A1.522,1.522,0,0,0,354.361,240.6Z",
    transform: "translate(-267.854 -134.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47833",
    "data-name": "Path 47833",
    d: "M385.312,232.5H320.971a1.741,1.741,0,0,0-1.712,1.621h0a1.522,1.522,0,0,0,1.537,1.621h64.341a1.741,1.741,0,0,0,1.712-1.621h0A1.522,1.522,0,0,0,385.312,232.5Z",
    transform: "translate(-261.26 -131.813)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(77.412 99.823)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16196",
    "data-name": "Group 16196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47834",
    "data-name": "Path 47834",
    d: "M169.746,170.889c-2.294,1.908-4.659,3.971-6.841,6.048-1.095,1.045-2.168,2.112-3.15,3.2a26.4,26.4,0,0,0-2.624,3.291l-.133.2-.07.112c-.049.056-.091.189-.147.281-.1.217-.189.491-.288.779a14.328,14.328,0,0,0-.435,1.951,41.453,41.453,0,0,0-.428,4.413c-.147,3.038-.147,6.2-.091,9.29l-3.284.491a59.717,59.717,0,0,1-1.684-9.683,37.03,37.03,0,0,1-.119-5.094,19.666,19.666,0,0,1,.33-2.75,11.418,11.418,0,0,1,.4-1.5,8.048,8.048,0,0,1,.323-.807l.2-.421c.063-.133.119-.21.175-.316a28.781,28.781,0,0,1,2.989-4.385c1.067-1.34,2.189-2.568,3.347-3.761a71.823,71.823,0,0,1,7.381-6.6l4.14,5.269Z",
    transform: "translate(-122.286 -132.841)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47835",
    "data-name": "Path 47835",
    d: "M172.41,160.9c-3.592,2.133-9.03,7.578-9.03,7.578l6.666,7.992s9.451-5.662,10.595-8.792c1.93-5.255-4.834-8.792-8.23-6.778Z",
    transform: "translate(-126.156 -131.26)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47836",
    "data-name": "Path 47836",
    d: "M155.934,213.475l.814,4.757-4.413-.638s-.905-3.228,1.375-4.343l2.224.225Z",
    transform: "translate(-122.808 -147.051)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47837",
    "data-name": "Path 47837",
    d: "M154.691,222.959l-3.971-1.235,1.186-2.294,4.413.638Z",
    transform: "translate(-122.379 -148.895)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47838",
    "data-name": "Path 47838",
    d: "M214.32,136.853c0,.484.274.877.589.884s.575-.386.568-.863-.274-.877-.589-.884S214.313,136.376,214.32,136.853Z",
    transform: "translate(-141.354 -124.001)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47839",
    "data-name": "Path 47839",
    d: "M214.92,135.886l1.165-.316S215.5,136.468,214.92,135.886Z",
    transform: "translate(-141.533 -123.875)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47840",
    "data-name": "Path 47840",
    d: "M214.91,137.9a13.316,13.316,0,0,0,1.782,3.108,2.084,2.084,0,0,1-1.733.3l-.049-3.4Z",
    transform: "translate(-141.53 -124.571)",
    fill: "#a02724"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47841",
    "data-name": "Path 47841",
    d: "M214.049,132.349a.483.483,0,0,1-.14-.007,2.358,2.358,0,0,0-2.084.246.286.286,0,1,1-.344-.456,2.935,2.935,0,0,1,2.61-.33.286.286,0,0,1,.182.358.272.272,0,0,1-.217.189Z",
    transform: "translate(-140.473 -122.703)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47842",
    "data-name": "Path 47842",
    d: "M192.395,144.56c.323,3.628-.891,9.571-3.635,11.591,0,0,2.063,3.817,8.679,4.7,7.269.975,3.852-3.115,3.852-3.115-3.866-1.473-3.452-4.385-2.47-7.031Z",
    transform: "translate(-133.729 -126.558)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47843",
    "data-name": "Path 47843",
    d: "M211.53,167.081c3.459.947,7.094,1.852,10.658,2.652,1.8.393,3.592.744,5.389,1.088,1.8.316,3.6.631,5.389.863l.674.091.456.049a9.033,9.033,0,0,0,1.059-.014,17.347,17.347,0,0,0,2.421-.33,49.3,49.3,0,0,0,5.143-1.347c3.459-1.088,6.974-2.386,10.4-3.733l1.558,2.926a74.465,74.465,0,0,1-10.153,5.564,45.236,45.236,0,0,1-5.6,2.091,22.634,22.634,0,0,1-3.122.7,17.037,17.037,0,0,1-1.754.147c-.309,0-.66-.007-.947-.021l-.73-.049a92.12,92.12,0,0,1-11.514-1.53,107.562,107.562,0,0,1-11.254-2.722l1.923-6.413Z",
    transform: "translate(-139.946 -133.074)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47844",
    "data-name": "Path 47844",
    d: "M270.37,166.632l1.017-3.452,3.74,1.4s-.856,5.178-4.063,3.747l-.695-1.705Z",
    transform: "translate(-158.077 -132.113)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47845",
    "data-name": "Path 47845",
    d: "M273.988,159.93l3.817.428-2.245,3.263-3.74-1.4Z",
    transform: "translate(-158.51 -131.143)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47846",
    "data-name": "Path 47846",
    d: "M178.64,401l6.013.449,1.789-13.816-6.013-.442Z",
    transform: "translate(-130.709 -198.946)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47847",
    "data-name": "Path 47847",
    d: "M115.44,365.37l4.084,4.533,11.409-7.887-4.084-4.526Z",
    transform: "translate(-111.854 -190.085)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47848",
    "data-name": "Path 47848",
    d: "M124.855,377.738a.784.784,0,0,1-.218-.035c-.73-.239-1.228-1.586-1.459-2.372a.148.148,0,0,1,.049-.154.138.138,0,0,1,.154-.014c.218.119,2.154,1.165,2.217,1.937a.484.484,0,0,1-.2.435.9.9,0,0,1-.54.2Zm-1.3-2.154c.344,1.038.772,1.712,1.165,1.845a.515.515,0,0,0,.491-.119.218.218,0,0,0,.1-.189C125.276,376.713,124.314,376.026,123.557,375.584Z",
    transform: "translate(-114.161 -195.353)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47849",
    "data-name": "Path 47849",
    d: "M125.086,375.6a4.337,4.337,0,0,1-1.845-.456.147.147,0,0,1-.07-.126.136.136,0,0,1,.07-.119c.063-.035,1.544-.856,2.365-.575a.765.765,0,0,1,.477.442.5.5,0,0,1-.105.617,1.38,1.38,0,0,1-.891.21Zm-1.459-.582a2.988,2.988,0,0,0,2.168.147c.049-.042.105-.119.028-.295a.479.479,0,0,0-.3-.281A3.22,3.22,0,0,0,123.626,375.02Z",
    transform: "translate(-114.16 -195.091)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47850",
    "data-name": "Path 47850",
    d: "M119.83,371.579l-3.368-5.978a.478.478,0,0,0-.589-.225l-4.975,1.908a.956.956,0,0,0-.435,1.368c1.207,2.063,1.894,3,3.375,5.627.912,1.614,2.315,5.143,3.4,7.466,1.052,2.273,3.368,1.41,3.122.351a21.153,21.153,0,0,1-.337-9.458,1.6,1.6,0,0,0-.182-1.067Z",
    transform: "translate(-110.329 -192.429)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47851",
    "data-name": "Path 47851",
    d: "M190.089,407.13a9.839,9.839,0,0,1-1.887-.217.151.151,0,0,1-.112-.119.141.141,0,0,1,.077-.147c.274-.14,2.715-1.368,3.438-.961a.452.452,0,0,1,.232.379.816.816,0,0,1-.274.695,2.323,2.323,0,0,1-1.466.365Zm-1.417-.414c1.326.218,2.315.161,2.687-.168a.518.518,0,0,0,.175-.463.151.151,0,0,0-.084-.147c-.4-.225-1.782.3-2.779.772Z",
    transform: "translate(-133.528 -204.44)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47852",
    "data-name": "Path 47852",
    d: "M188.22,406.319a.221.221,0,0,1-.084-.028.135.135,0,0,1-.056-.133c.014-.105.288-2.568,1.635-2.568h.119c.393.042.5.239.526.393.112.681-1.347,1.986-2.077,2.308a.166.166,0,0,1-.056.014Zm1.5-2.442c-.87,0-1.207,1.431-1.319,2.042.751-.449,1.74-1.473,1.677-1.88,0-.035-.021-.133-.274-.154h-.084Z",
    transform: "translate(-133.525 -203.839)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47853",
    "data-name": "Path 47853",
    d: "M184.278,406.28h-6.757a.491.491,0,0,0-.491.414l-.905,5.347a.946.946,0,0,0,.94,1.074c2.358-.042,3.494-.175,6.469-.175,1.831,0,5.606.189,8.132.189s2.722-2.5,1.677-2.722c-4.687-1.017-6.511-2.414-8.062-3.747a1.552,1.552,0,0,0-1-.372Z",
    transform: "translate(-129.956 -204.642)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16194",
    "data-name": "Group 16194",
    transform: "translate(10.126 167.405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47854",
    "data-name": "Path 47854",
    d: "M186.809,387.642l-1,7.676-5.943-1,.919-7.122Z",
    transform: "translate(-141.202 -366.354)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47855",
    "data-name": "Path 47855",
    d: "M129.622,357.49l4.084,4.533-4.715,3.256-4.231-4.427Z",
    transform: "translate(-124.76 -357.49)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47856",
    "data-name": "Path 47856",
    d: "M174.29,197.058l24.354,3.27c9.437-34.163,6.652-35.09,6.652-35.09a49.655,49.655,0,0,0-5.613-2.224c-.119-.042-.232-.07-.337-.105-1.572-.47-1.9-.54-4-1.017-3.592-.631-6.939-1.123-11.058-1.48-.267-.021-.526-.049-.786-.063-.744-.049-1.48-.084-2.2-.112-.484-.028-.961-.028-1.417-.035h-1.558c-.281,0-.554,0-.814.014a3.373,3.373,0,0,0-3.277,3.761c2.077,17.969,1.41,23.877.049,33.076Z",
    transform: "translate(-129.39 -131.224)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47857",
    "data-name": "Path 47857",
    d: "M210.03,177.614c.168,1.586,3.831,4.484,5.094,3.7.372-1.894.631-3.48.821-4.8-1.859-.133-5.459-2.168-5.915,1.1Z",
    transform: "translate(-140.074 -135.868)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47858",
    "data-name": "Path 47858",
    d: "M204.369,166.06c-.175-5.592,13.43.568,16.552,1.965l-3.452,9.388s-4.554-.161-7.452-1.831a11.768,11.768,0,0,1-5.641-9.514Z",
    transform: "translate(-138.385 -132.284)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47859",
    "data-name": "Path 47859",
    d: "M191.007,131.353c.449,5.936.512,8.455,3.578,11.535,4.617,4.638,11.872,3,13.219-2.9,1.214-5.311.274-14.124-5.627-16.566A7.958,7.958,0,0,0,191,131.353Z",
    transform: "translate(-134.39 -120.052)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47860",
    "data-name": "Path 47860",
    d: "M182.984,123.932c-5.964-1.487-6.146,3.543-6.027,6.146s-4.259,3.9-4.259,7.206c0,4.308,3.249,6.876-4.652,8.181-6.694,1.1-8.75,9.458,1.144,14.349,10.953,5.41,27.477-2.2,25.463-9.437-3.1-11.163,2.449-11.128,1.824-17.359-.456-4.533,3.838-4.757,2.294-8.539-2.021-4.961-16.32-9.311-15.794-.547Z",
    transform: "translate(-125.862 -118.903)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47861",
    "data-name": "Path 47861",
    d: "M181.731,134.023c-.821-4.315-.372-7.185,1.333-8.525,2.2-1.726,5.571-.232,5.718-.161l-.288.639s-3.136-1.389-5,.077c-1.48,1.165-1.845,3.8-1.074,7.837l-.688.133Z",
    transform: "translate(-131.512 -120.623)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47862",
    "data-name": "Path 47862",
    d: "M170.381,152.24a13.64,13.64,0,0,1-4.491-.905l.26-.653c.049.021,4.778,1.873,6.96.063,1.067-.884,1.368-2.547.905-4.933l.688-.133c.519,2.659.133,4.547-1.144,5.606a4.91,4.91,0,0,1-3.178.954Z",
    transform: "translate(-126.905 -126.892)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47863",
    "data-name": "Path 47863",
    d: "M208.683,137.867a5.4,5.4,0,0,0,.821,3.143c.814,1.326,1.915,1.081,2.273-.042a4.017,4.017,0,0,0-.807-3.887c-1.081-.947-2.175-.442-2.287.786Z",
    transform: "translate(-139.668 -124.179)",
    fill: "#b55b52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47864",
    "data-name": "Path 47864",
    d: "M177.667,215.134s-9.458,39.973-13.879,62.931c-4.666,24.228-32.276,43.986-32.276,43.986l-6.062-6.238s17.78-15.563,22.348-38.184c9.269-45.916,3-55.164,11.942-64.91l17.927,2.407Z",
    transform: "translate(-114.84 -146.893)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47865",
    "data-name": "Path 47865",
    d: "M131.611,365.546l-7.571-7.788,2.126-2.287,8.792,7.739Z",
    transform: "translate(-114.419 -189.483)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47866",
    "data-name": "Path 47866",
    d: "M190.044,228.071c-7.353,6.385-6.56,29.034-5.789,39.243,3.087-14.517,6.792-30.676,8.967-40.029C192.451,226.7,191.391,226.9,190.044,228.071Z",
    transform: "translate(-132.241 -151.144)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47867",
    "data-name": "Path 47867",
    d: "M199.405,216.4s4.252,47.453,1.937,65.555c-2.414,18.825-14.7,59.788-14.7,59.788l-8.672-1.123s7.045-40.59,8.3-59.233c1.368-20.32-4.694-67.387-4.694-67.387l17.836,2.393Z",
    transform: "translate(-130.509 -147.275)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47868",
    "data-name": "Path 47868",
    d: "M187.693,394.538l-12.363-1.6.189-3.649,13.416,1.3Z",
    transform: "translate(-129.722 -199.573)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16195",
    "data-name": "Group 16195",
    transform: "translate(43.333 64.236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47869",
    "data-name": "Path 47869",
    d: "M173.443,210.584l-1.326,2.014c-.105.154.077.358.358.393l25.54,3.431c.218.028.414-.056.442-.189l.449-2.133c.028-.147-.147-.3-.386-.33l-24.663-3.312a.44.44,0,0,0-.414.126Z",
    transform: "translate(-172.087 -210.453)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47870",
    "data-name": "Path 47870",
    d: "M173.443,210.584l-1.326,2.014c-.105.154.077.358.358.393l25.54,3.431c.218.028.414-.056.442-.189l.449-2.133c.028-.147-.147-.3-.386-.33l-24.663-3.312a.44.44,0,0,0-.414.126Z",
    transform: "translate(-172.087 -210.453)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_47871",
    "data-name": "Path 47871",
    d: "M177.952,213.825l-.66-.091c-.133-.021-.225-.1-.2-.182l.61-2.772c.021-.084.14-.133.274-.112l.66.091c.133.021.225.1.2.182l-.61,2.772C178.2,213.8,178.085,213.846,177.952,213.825Z",
    transform: "translate(-130.246 -146.279)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47872",
    "data-name": "Path 47872",
    d: "M201.732,217.075l-.66-.091c-.133-.021-.225-.1-.2-.182l.61-2.772c.021-.084.14-.133.274-.112l.66.091c.133.021.225.1.2.182l-.61,2.772C201.984,217.047,201.865,217.1,201.732,217.075Z",
    transform: "translate(-137.34 -147.249)",
    fill: "#263238"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentHover83);
export default __webpack_public_path__ + "static/media/ComponentHover83.80f07ed591d176b8c4f6ea7a1754dfa4.svg";
export { ForwardRef as ReactComponent };